import * as types from './mutation-types'

export default {
  [types.UPDATE_LASTP](state, data) {
    state.lastp = data
  },
  // 用户
  [types.UPDATE_USER_AUTH](state, data) {
    state.auth = data
  },
  [types.UPDATE_USER_TICKET](state, data) {
    state.ticket = data
  },
  [types.UPDATE_USER_INFO_OBJ](state, data) {
    state.userInfoObj = data
  },

  // 平台
  [types.UPDATE_BRAND](state, data) {
    state.brand = data
    localStorage.setItem('mp-brand', data)
  },
  [types.UPDATE_NAV_MENU_COLLAPSE](state, data) {
    state.navMenuCollapse = data
  },
  [types.UPDATE_NEW_MSG](state, data) {
    state.newMsg = data
  },

  [types.UPDATE_SHOW_VIDEO_UPLOAD](state, data) {
    state.showVideoUpload = data
  },
  [types.UPDATE_UPLOAD_VIDEO_LIST](state, data) {
    state.uploadVideoList = data
  },

  // 剩余
  [types.UPDATE_REDUCE_INFO](state, data) {
    state.reduceObj = data
  },

  // 下载信息
  [types.UPDATE_DOWNLOAD_INFO](state, data) {
    state.waitDownloadCount = data
  },

  // 剧本分析筛选条件
  [types.UPDATE_SCENARIO_CATEGORY](state, data) {
    state.scenarioCategory = data
  }
}
